import { getFormattedDate } from 'forms-utils-lib/date/getFormattedDate';
import { FORM_EDITOR_DATE_FORMAT_SEPARATORS, FORM_EDITOR_DATE_FORMATS } from 'forms-utils-lib/date/DateConstants';
export const getUISelectDateFormatOptions = (getTextKey = separator => separator) => Object.keys(FORM_EDITOR_DATE_FORMAT_SEPARATORS).flatMap(separator => {
  const allOptions = FORM_EDITOR_DATE_FORMATS.map(format => ({
    text: getFormattedDate(format, separator),
    value: {
      format,
      separator
    }
  }));
  const key = FORM_EDITOR_DATE_FORMAT_SEPARATORS[separator];
  return {
    text: getTextKey(key) || key,
    options: allOptions
  };
});